import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService  } from '../../../../generated-sources/openapi/api/auth.service';
import { LoginService } from '../../core/services/login.service';

@Component({
  selector: 'app-login',
  imports: [FormsModule, MatButtonModule, MatCardModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  email = 'admin@frakcio.com';
  password = '12345678';
  loading = false;
  errorMessage = '';

  constructor(
    private authService: AuthService,
    private loginService: LoginService,
    private router: Router,
  ) {}

  login(): void {
    if (!this.email || !this.password) {
      this.errorMessage = 'Captura usuario y contrasena';
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    this.authService.authLoginPost({ email: this.email, password: this.password }).subscribe({
      next: (response) => {
        const data = response.data;
        if (!data || !data.token) {
          this.errorMessage = 'La respuesta no incluyo token de acceso';
          this.loading = false;
          return;
        }

        this.loginService.login(data.token, data);
        this.router.navigate(['/']);
      },
      error: () => {
        this.errorMessage = 'No se pudo iniciar sesion';
        this.loading = false;
      }
    });
  }
}
